export default __webpack_public_path__ + "static/media/459.2f35016d.png";